import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from "../../../../api/axios";

import { TextField, IconButton } from "@mui/material";

import { SearchOutlined } from "@mui/icons-material";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { FormGroup, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";

import AddIcon from "@mui/icons-material/Add";
import ContentCopy from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { url } from "../../../../configlink";

import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";

import "./admin_acgtcards.css";
import { useLocation } from "react-router-dom";

export default function ACGTCardTransactionHistory() {
  const [paymentHistoryRows, setPaymentHistoryRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialogName, setOpenDialog] = useState(null);
  const [userId, setUserId] = useState(0);
  const paymentId = useRef();
  const [acgtCardTransactionHistoryData, setACGTCardTransactionHistoryData] =
    useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});

  const [filteredRows, setFilteredRows] = useState([]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  let loc = useLocation();
  let [acgtcardData, setACGTCardData] = useState([]);

  useEffect(() => {
    let data = loc.search.split("=")[1];
    console.log(data);
    getAcgtcardDetals(data);
  }, []);

  async function getAcgtcardDetals(x) {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_admin_acgtcard_edit_detail`,
        {
          params: {
            id: x,
          },
          withCredentials: true,
        }
      );
      console.log(response.data);
      let card = response.data[0];
      setACGTCardData(card);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (acgtcardData) {
      console.log(acgtcardData);

      getTransactionHistoryData();
    }
  }, [acgtcardData]);

  const styles = {
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      width: 300,
      margin: 100,
    },
    // style for font size
    resize: {
      fontSize: 50,
    },
  };

  /*
  const handleFilter = (event) => {
    const value = event.target.value;
    const filtered = users.filter(user => user.name.includes(value));
    setFilteredUsers(filtered);
  };
  */

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleEditClick2 = (id) => {
    const url = `/editacgtcardtransaction?userId=${acgtcardData.UserId}&cardId=${acgtcardData.id}&trId=${id}`;
    const width = 650;
    const height = 800;

    const left = 100;
    const top = 100;

    window.open(
      url,
      "_blank",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  };

  const getACGTCardTransactionHistoryView = async (data) => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_acgtcard_transaction_history`,
        {
          params: {
            userId: data,
            acgtCardId: data,
          },
          withCredentials: true,
        }
      );
      setACGTCardTransactionHistoryData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getACGTCardDetails = async (data) => {};

  const closeDialog = () => {
    setOpenDialog(null);
    paymentId.current = 0;
  };

  const openDialog = () => {};

  const getTransactionHistoryData = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_acgtcard_transaction_history`,
        {
          params: {
            userId: acgtcardData.UserId,
            acgtCardId: acgtcardData.id,
          },
          withCredentials: true,
        }
      );
      console.log(response.data);

      setACGTCardTransactionHistoryData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  /*

  const handleCategoryChange = event => {
    setCategory(event.target.value);
  };

  const handleItemChange = event => {
    setItem(event.target.value);
  };

  const handleEditClick = id => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = id => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = id => () => {
    setRows(rows.filter(row => row.id !== id));
  };

  const handleCancelClick = id => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find(row => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter(row => row.id !== id));
    }
  };

  const processRowUpdate = newRow => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map(row => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = newRowModesModel => {
    setRowModesModel(newRowModesModel);
  };

  const handleCopyPrice = () => {
    setOpenDialog('price_change_dlg');
    openDialog();
  };
  */

  const columns = [
    { field: "id", headerName: "id", type: "number", hide: true },
    {
      field: "spdate",
      headerName: "Date",
      type: "string",
      width: 120,
      editable: false,
    },
    {
      field: "FullName",
      headerName: "Full Name",
      type: "string",
      width: 180,
      editable: false,
    },
    {
      field: "stype",
      headerName: "Type",
      type: "string",
      width: 320,
      editable: false,
    },
    {
      field: "Amount",
      headerName: "Amount",
      type: "string",
      width: 100,
      editable: true,
    },
    {
      field: "SubTotal",
      headerName: "SubTotal",
      type: "string",
      width: 100,
      editable: false,
    },
    {
      field: "type",
      headerName: "Status",
      type: "string",
      width: 2,
      editable: false,
      hide: true,
    },
    {
      field: "ref_number",
      headerName: "Amount",
      type: "string",
      width: 2,
      editable: false,
      hide: true,
    },
    {
      field: "acgtcardid",
      headerName: "Status",
      type: "string",
      width: 2,
      editable: false,
      hide: true,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 80,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            key={id}
            onClick={() => handleEditClick2(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<CancelIcon />}
            label="Cancel"
            className="textPrimary"
            key={id}
            // onClick={handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const [isOpened, setIsOpened] = useState(false);

  return (
    <div>
      <div style={{ height: 400, width: "100%" }}>
        <div className="App">
          <div style={{ paddingTop: 20 }}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                color: "var(--color-primary-purple)",
              }}
              align="Center"
            >
              ACGT Card Transaction History
            </Typography>
          </div>
          <Divider
            style={{
              marginTop: 10,
              marginBottom: 30,
              marginLeft: 20,
              marginRight: 20,
            }}
          />
          <div className="container2">
            <main className="main2">
              <DataGrid
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      //  Hide columns status and traderName, the other columns will remain visible
                      id: false,
                      ref_number: false,
                      acgtcardid: false,
                      type: false,
                    },
                  },
                }}
                style={{ width: "100%", height: "95%" }}
                columnHeaderHeight={35}
                rowHeight={40}
                rows={acgtCardTransactionHistoryData}
                columns={columns}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    color: "var(--color-primary-purple)",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                  },
                }}
                pageSize={15}
                //slots={{
                //  toolbar: EditToolbar,
                //}}
                slotProps={{
                  toolbar: {
                    setACGTCardTransactionHistoryData,
                    setRowModesModel,
                  },
                }}
              />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
